import SigninContent from "../components/auth/SigninContent";


const Signin = () => {
    return (
        <div>
            <SigninContent />
        </div>
    )
}

export default Signin;